export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-lock-bdeda49a161e48fa9af29f53fffc6fec.svg";